import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import service from "./service";
import {
  reduxSliceData,
} from "../store/slices/reduxData";
import {
  trimValues,
} from "./common-function/commonFunction";
type DownloadParams = {
  storedFileName: string;
  originalFileName: string;
  clarificationId?: number;
  customerResponseId?: number;
  rfqId: number;
  docId: number;
};



const CustomHookApi = (apiUrl?: any, pageUrl?: any) => {
  const [listData, setListData] = useState<any>([]);
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);

  const fetchData = async (url?: string, baseType?: string) => {
    try {
      const requestOptions: any = {
        methodName: service.Methods.GET,
        apiUrl: url || apiUrl,
      };
      if (baseType) {
        requestOptions.baseType = baseType;
      }
      const response: any = await service.makeAPICall(requestOptions);
      // if (response.status == 401) {
      //   route.push('/login')
      //   localStorage.clear()
      // }
      if (response?.apiStatus) {
        return response;
      } else {
        setTimeout(() => {
          dispatch(reduxSliceData({ key: "loadingApiStatus", data: false }));
        }, 2000);
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (apiUrl) {
      fetchData();
    }
  }, [apiUrl]);

  const addData = async (
    newItem: any,
    apiUrl: string,
    baseType?: any,
    formDataCheck?: any,
  ) => {
    try {
      const trimmedItem = formDataCheck ? newItem : trimValues(newItem);

      const requestOptions: any = {
        methodName: service.Methods.POST,
        apiUrl,
        body: trimmedItem,
      };

      if (baseType) {
        requestOptions.baseType = baseType;
      }
      const response: any = await service.makeAPICall(requestOptions);

      if (response?.apiStatus) {
        response?.apiMessage 
        return response;
      } else {
        return response;
      }
    } catch (err) {}
  };

  const updateData = async (
    updatedItem: any,
    apiUrl: string,
    baseType?: any,
    formDataCheck?: boolean,
  ) => {
    try {
      const trimmedItem = formDataCheck ? updatedItem : trimValues(updatedItem);
      const requestOptions: any = {
        methodName: service.Methods.PUT,
        apiUrl: apiUrl,
        body: trimmedItem,
      };
      if (baseType) {
        requestOptions.baseType = baseType;
      }
      const response: any = await service.makeAPICall(requestOptions);

      if (response?.apiStatus) {
        
        dispatch(reduxSliceData({ key: "commonStatus", data: true }));
        return response;
      } else {

      }
      return response;
    } catch (err) {}
  };
  const updateShopData = async (
    updatedItem: any,
    apiUrl: string,
    shopUpdate?: boolean,
  ) => {
    try {
      setLoading(true);
      const trimmedItem = trimValues(updatedItem);
      const response: any = await service.makeAPICall({
        methodName: service.Methods.PUT,
        apiUrl: `${apiUrl}`,
        body: trimmedItem,
      });

      if (response?.apiStatus) {
        return response;
      }
      let errorMessages = "";
      if (Array.isArray(response?.apiErrorData)) {
        errorMessages = response?.apiErrorData
          .map((errorObject: any) => Object.values(errorObject).join(" "))
          .join(" ");
      } else if (
        typeof response?.data?.apiErrorData ||
        response?.apiErrorData === "string"
      ) {
        errorMessages = response?.data?.apiErrorData || response?.apiErrorData;
      }
    
    } catch (err) {}
  };

  const getListData = async (apiUrls: { [key: string]: string }) => {
    try {
      const responses: any = await Promise.all(
        Object.entries(apiUrls).map(async ([key, url]) => {
          const response = await service.makeAPICall({
            methodName: service.Methods.GET,
            apiUrl: url,
          });
          return { key, response };
        }),
      );
      // let enable = false;
      responses.forEach(({ key, response }: any) => {
        if (response?.apiStatus) {
          //  response?.apiData?.filter((item: any) => item?.status) // Filter by status if enable is false
          setListData((prevData: any) => ({
            ...prevData,
            [key]: response?.apiData,
          }));
        } else {
        }
      });
    } catch (error) {}
  };

  const getListDataWithInstance = async (apiUrls: {
    [key: string]: {
      url: string;
      instance?:
        | "security"
        | "erp"
        | "crm"
        | "crmIatf"
        | "commonmaster"
        | "common";
      query?: Record<string, any>;
    };
  }) => {
    try {
      const responses: any = await Promise.all(
        Object.entries(apiUrls).map(async ([key, { url, instance, query }]) => {
          const response = await service.makeAPICall({
            methodName: service.Methods.GET,
            apiUrl: url,
            query,
            baseType: instance as any,
          });
          return { key, response };
        }),
      );

      responses.forEach(({ key, response }: any) => {
        if (response?.apiStatus) {
          // Normalize response here
          const data = response?.apiData?.items ?? response?.apiData ?? [];

          setListData((prevData: any) => ({
            ...prevData,
            [key]: data,
          }));
        }
      });
    } catch (error) {
      console.error("getListData error:", error);
    }
  };

  const getItemById = async (
    id: any,
    url?: string,
    baseType?: string,
    queryParams?: any,
  ) => {
    try {
      const requestOptions: any = {
        methodName: service.Methods.GET,
        apiUrl: url || apiUrl,
        params: id,
        query: queryParams,
      };
      if (baseType) {
        requestOptions.baseType = baseType;
      }

      const response: any = await service.makeAPICall(requestOptions);
      if (response?.apiStatus) {
        return response.apiData;
      }
    } catch (err) {}
  };

  const getQueryFetch = async (
    queryParams: Record<string, any>,
    apiUrl: string,
    baseType?: string,
    pageUrl?: any,
  ) => {
    try {
      const trimmedItem = trimValues(queryParams);
      const config: any = {
        methodName: service.Methods.GET,
        apiUrl,
        query: trimmedItem,
      };

      if (baseType) {
        config.baseType = baseType;
      }

      const response: any = await service.makeAPICall(config);
      if (!response?.apiStatus) {
        // apiCallCommon(response);
        return;
      }

     
      const apiData = response?.apiData;

      // if (returnFullResponse) return apiData;

      if (Array.isArray(apiData?.items)) {
        return apiData.items.map((item: any) => ({
          ...item,
          ...(apiData?.monthHeaders
            ? { monthHeaders: apiData.monthHeaders }
            : null),
          totalRecords: apiData?.totalCount || apiData?.totalRecords || 0,
        }));
      }

      if (Array.isArray(apiData)) {
        return apiData;
      }

      if (apiData && typeof apiData === "object") {
        return [apiData];
      }

      return [];
    } catch (err) {
      console.error("getQueryFetch error:", err);
    }
  };

  

  
  

  return {
    fetchData,
    addData,
    updateData,
    listData,
    getListData,
    getItemById,
    getQueryFetch,
    getListDataWithInstance,
    updateShopData,
  };
};

export default CustomHookApi;
